export const cifSs = ["301 151","<g fill-rule='nonzero' fill='none'><path fill='#078930' d='M.5 105.5h300v45H.5z'/><path fill='#FFF' d='M.5 45.5h300v60H.5z'/><path fill='#000' d='M.5.5h300v45H.5z'/><path fill='#DA121A' d='M.5 53h300v45H.5z'/><path fill='#0F47AF' d='M.5.5l129.904 75L.5 150.5z'/><path fill='#FCDD09' d='M19.801 75.5l43.417 14.107-26.833-36.932v45.65l26.833-36.932z'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-ss.js
// module id = null
// module chunks = 